export default "__VITE_ASSET__BKXycCfy__";